let TimeTitleService = function (Restangular) {
    const ServiceAPI = Restangular.all('admin/schedule_titles');

    let getTimeTitleList = (query) => {
      return Restangular.all('schedule_titles').customGET("", query);
    }
  
    let save = (resource) => {
      if (resource.id) {
        let copyData = angular.copy(resource);
        delete copyData.id;
        return ServiceAPI.customPUT(copyData, resource.id);
      } else {
        return ServiceAPI.post(resource);
      }
    }
  
    let destroy = (resource) => {
      return ServiceAPI.customDELETE(resource.id);
    }
  
    return { getTimeTitleList, save, destroy } ;
  };
  
  TimeTitleService.$inject = ['Restangular'];
  
  export default TimeTitleService;
  


// WEBPACK FOOTER //
// ./client/app/components/title-time/time-title.service.js